export const isModalOpened = () => Boolean(document.querySelectorAll('.modal-content').length);
